import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiservicehinjewadipune() {



const cardData = {
  keyword: " Taxi Service in Hinjewadi Pune",

"headingDescription": "SRS Cab Service offers Taxi Service in Hinjewadi Pune, providing reliable, comfortable, and efficient transportation for daily commuting, IT professionals, corporate travel, and airport transfers. Our well-maintained vehicles, experienced drivers, and punctual service ensure a smooth and hassle-free journey across Hinjewadi and Pune city. Ideal for office travel, airport pickups and drops, and outstation trips, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and stress-free travel experience.",
"topPlaces": [
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "Rajiv Gandhi Infotech Park is the main IT hub in Hinjewadi. Travelers using Taxi Service in Hinjewadi Pune from SRS Cab Service often commute here for office work and business meetings."
  },
  {
    "title": "Xion Mall",
    "description": "Xion Mall is a popular shopping and entertainment destination in Hinjewadi. Visitors using SRS Cab Service often visit for shopping, dining, and movies."
  },
  {
    "title": "Balewadi High Street",
    "description": "Balewadi High Street is a trendy area near Hinjewadi known for restaurants and nightlife. Travelers using SRS Cab Service often visit for food and leisure activities."
  },
  {
    "title": "Balewadi Stadium",
    "description": "Balewadi Stadium is a major sports complex near Hinjewadi. Visitors using SRS Cab Service often travel here for sports events and activities."
  },
  {
    "title": "Baner Hills",
    "description": "Baner Hills is a scenic spot popular for trekking and sunset views. Travelers using SRS Cab Service often visit for outdoor activities and relaxation."
  },
  {
    "title": "Pashan Lake",
    "description": "Pashan Lake is a peaceful natural spot near Hinjewadi. Visitors using SRS Cab Service often relax here and enjoy bird watching and scenic surroundings."
  },
  {
    "title": "Aundh",
    "description": "Aundh is a nearby locality known for shopping and dining options. Travelers using SRS Cab Service often visit this area for leisure and daily needs."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort in Pune city. Visitors using SRS Cab Service often explore this landmark to learn about Pune’s heritage."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is a famous religious site in Pune. Travelers using SRS Cab Service often visit to seek blessings."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort near Pune known for its scenic views. Visitors using SRS Cab Service often include this destination for trekking and sightseeing."
  }
],



services: [
{
name: "Hinjewadi Taxi Service",
description: "Hinjewadi taxi service offers reliable transportation for IT professionals and residents. Customers can book taxis for daily and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services in Hinjewadi."
},
{
name: "Taxi Booking Hinjewadi",
description: "Taxi booking Hinjewadi provides quick and easy reservation options. Customers can book taxis online or via phone. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily in Hinjewadi."
},
{
name: "Taxi in Hinjewadi Pune",
description: "Taxi in Hinjewadi Pune offers convenient travel for local and office routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Service Hinjewadi",
description: "Cab service Hinjewadi provides dependable transportation for daily and business travel. Customers can book cabs for city and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Hinjewadi Cab Booking",
description: "Hinjewadi cab booking offers fast reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily in Hinjewadi."
},
{
name: "Reliable Taxi Hinjewadi",
description: "Reliable taxi Hinjewadi provides trusted transportation for daily and corporate travel. Customers can book dependable taxi services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with reliable taxi services."
},
{
name: "Affordable Taxi Hinjewadi",
description: "Affordable taxi Hinjewadi offers budget-friendly travel for daily and office commutes. Customers can book taxis at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with affordable taxi services."
},
{
name: "24/7 Taxi Service Hinjewadi",
description: "24/7 taxi service Hinjewadi provides round-the-clock transportation for customers. Travelers can book taxis anytime for urgent needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with 24/7 taxi services."
},
{
name: "Luxury Taxi Hinjewadi",
description: "Luxury taxi Hinjewadi provides premium travel experience for corporate and personal use. Customers can enjoy high-end vehicles with comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel comfortably with luxury taxi services."
},
{
name: "Taxi Service in Hinjewadi",
description: "Taxi service in Hinjewadi offers reliable transportation for local and outstation trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Hinjewadi Cab Service Pune",
description: "Hinjewadi cab service Pune provides convenient travel solutions for IT employees and residents. Customers can book cabs for office and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Hinjewadi Cab Service Pune Contact Number",
description: "Hinjewadi cab service Pune contact number provides easy access to booking support. Customers can call and reserve cabs instantly. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily through contact services."
},
{
name: "Taxi Service in Hinjewadi Pune",
description: "Taxi service in Hinjewadi Pune offers dependable transportation for city and office travel. Customers can book taxis for flexible trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune Airport to Hinjewadi Taxi Fare",
description: "Pune airport to Hinjewadi taxi fare provides estimated pricing for airport travel. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Cab Service in Hinjewadi Pune",
description: "Cab service in Hinjewadi Pune provides reliable transportation for local and outstation travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Pune for Outstation",
description: "Cab service in Pune for outstation offers long-distance travel solutions for customers. Users can book cabs for tours and business trips. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Monthly Taxi Service in Hinjewadi",
description: "Monthly taxi service in Hinjewadi provides long-term travel solutions for IT employees and offices. Customers can book cabs on monthly plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with monthly taxi services."
},
{
name: "Office Cab Service in Pune",
description: "Office cab service in Pune offers reliable transportation for corporate employees. Companies can book cabs for daily office commutes. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with office cab services."
},
{
name: "Cab Service in Hinjewadi Phase 3",
description: "Cab service in Hinjewadi Phase 3 provides convenient travel for IT park employees. Customers can book cabs for office and home travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Tempo Traveller on Rent in Hinjewadi",
description: "Tempo traveller on rent in Hinjewadi offers group travel solutions for tours and events. Customers can book spacious vehicles for family and corporate trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Mini Bus on Rent in Hinjewadi",
description: "Mini bus on rent in Hinjewadi provides large group travel solutions. Customers can book buses for corporate and family trips. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with mini bus services."
},
{
name: "Hinjewadi to Mumbai Cab",
description: "Hinjewadi to Mumbai cab offers reliable intercity travel for business and airport trips. Customers can book cabs for comfortable journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Hinjewadi to Mumbai Airport Cab",
description: "Hinjewadi to Mumbai airport cab provides convenient airport transfer services. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Best Cab Service in Hinjewadi Pune",
description: "Best cab service in Hinjewadi Pune offers top-rated transportation for customers. Travelers can enjoy high-quality service and comfort. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Hinjewadi",
description: "Cheap cab service Hinjewadi provides budget-friendly transportation for daily travel. Customers can book cabs at affordable rates. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheap cab services."
},
{
name: "Affordable Cab Service Hinjewadi",
description: "Affordable cab service Hinjewadi offers cost-effective travel for local and outstation trips. Customers can book cabs at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with affordable cab services."
},
{
name: "Hinjewadi Cab Hire",
description: "Hinjewadi cab hire provides flexible vehicle options for personal and business travel. Customers can hire cabs for local and outstation journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Hire cabs easily in Hinjewadi."
},
{
name: "Hinjewadi Taxi Hire",
description: "Hinjewadi taxi hire offers convenient transportation for daily and corporate travel. Customers can hire taxis for flexible trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
}
],

tableData: [
["Hinjewadi Taxi Service","Taxi Booking Hinjewadi"],
["Taxi in Hinjewadi Pune","Cab Service Hinjewadi"],
["Hinjewadi Cab Booking","Reliable Taxi Hinjewadi"],
["Affordable Taxi Hinjewadi","24/7 Taxi Service Hinjewadi"],
["Luxury Taxi Hinjewadi","Taxi Service in Hinjewadi"],
["Hinjewadi Cab Service Pune","Hinjewadi Cab Service Pune Contact Number"],
["Taxi Service in Hinjewadi Pune","Pune Airport to Hinjewadi Taxi Fare"],
["Cab Service in Hinjewadi Pune","Cab Service in Pune for Outstation"],
["Monthly Taxi Service in Hinjewadi","Office Cab Service in Pune"],
["Cab Service in Hinjewadi Phase 3","Tempo Traveller on Rent in Hinjewadi"],
["Mini Bus on Rent in Hinjewadi","Hinjewadi to Mumbai Cab"],
["Hinjewadi to Mumbai Airport Cab","Best Cab Service in Hinjewadi Pune"],
["Cheap Cab Service Hinjewadi","Affordable Cab Service Hinjewadi"],
["Hinjewadi Cab Hire","Hinjewadi Taxi Hire"]
],



whychoose: [
  {
    WhyChooseheading: "Expert Service in Hinjewadi IT Hub",
    WhyChoosedescription: "SRS Cab Service offers reliable taxi service in Hinjewadi Pune with drivers familiar with Phase 1, Phase 2, Phase 3, Rajiv Gandhi Infotech Park, and all major IT companies."
  },
  {
    WhyChooseheading: "Affordable Taxi Service with Transparent Pricing",
    WhyChoosedescription: "We provide budget-friendly taxi service in Hinjewadi with clear fare structure. Customers get upfront pricing without hidden charges."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability for All Shifts",
    WhyChoosedescription: "SRS Cab Service operates 24/7, ideal for IT professionals working in night shifts, early morning schedules, and flexible office timings."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and fully air-conditioned vehicles ensuring a comfortable ride within Hinjewadi and across Pune."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for local, corporate, and outstation travel."
  },
  {
    WhyChooseheading: "Fast Airport Pickup & Drop Service",
    WhyChoosedescription: "We provide quick and reliable airport transfers from Hinjewadi to Pune Airport with on-time pickup and smooth travel experience."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our drivers are trained, verified, and experienced to ensure safe driving, professional behavior, and a hassle-free journey."
  },
  {
    WhyChooseheading: "Trusted Taxi Service in Hinjewadi Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by IT employees and residents for punctual, affordable, and dependable taxi service in Hinjewadi."
  }
]
}

const faqData = [
  { question: "Do you provide taxi service in Hinjewadi Pune?", answer: "Yes, SRS Cab Service offers reliable taxi services in Hinjewadi for local and outstation travel." },
  { question: "Is taxi service available in Hinjewadi 24 hours?", answer: "Yes, our taxi service operates 24/7 for all travel needs including night shifts." },
  { question: "Do you provide airport taxi from Hinjewadi?", answer: "Yes, we provide Pune Airport pickup and drop services from Hinjewadi." },
  { question: "Which areas do you cover in Hinjewadi?", answer: "We cover Phase 1, Phase 2, Phase 3, Marunji, Wakad, and nearby areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book taxi online in Hinjewadi?", answer: "Yes, you can easily book taxi service online or via phone." },
  { question: "Do you provide corporate cab service in Hinjewadi?", answer: "Yes, we provide employee transport and corporate cab services for IT companies." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and professional." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "Booked taxi from Hinjewadi Phase 2 to airport. Very quick pickup and smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Patil",
    feedback:
      "Best taxi service in Hinjewadi. Clean car, polite driver, and always on time.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Hinjewadi Taxi Service",
  "description": "Reliable cab and taxi service in Hinjewadi, Pune. Book local rides, airport transfers, outstation trips, and corporate travel with SRS Cab. Available 24/7 with luxury and standard vehicles.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Hinjewadi",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411057",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5905",
    "longitude": "73.7407"
  },
  "url": "https://www.srscabservice.com/hinjewadi-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1420"
  },
  "areaServed": {
    "@type": "City",
    "name": "Hinjewadi, Pune"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Taxi Service in Hinjewadi Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable taxi and cab service in Hinjewadi, Pune with SRS Cab. Local rides, airport transfers, outstation trips, and corporate travel available 24/7. Luxury and standard vehicles provided." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiservicehinjewadipune;